import PropTypes from "prop-types"
import { STATUS_TABS } from "../constants"
import styles from "./index.module.css"

// Lifecycle sub-tabs for the All Reservations listing (Upcoming / Requests / Completed / Canceled).
// `status` is the active API status value; `counts` maps each status key to its badge count.
const ReservationStatusTabs = ({ status = "upcoming", counts = {}, onChange }) => (
  <div className={styles.tabs}>
    {Object.entries(STATUS_TABS).map(([key, { label }]) => (
      <button
        key={key}
        type="button"
        className={`${styles.tab} ${status === key ? styles.tabActive : ""}`}
        onClick={() => onChange?.(key)}
      >
        {label}
        {counts[key] > 0 && <span className={styles.count}> {counts[key]}</span>}
      </button>
    ))}
  </div>
)

ReservationStatusTabs.propTypes = {
  status: PropTypes.oneOf(Object.keys(STATUS_TABS)),
  counts: PropTypes.object,
  onChange: PropTypes.func
}

export default ReservationStatusTabs
